import React, { Fragment, useState, useEffect } from "react";
import { Redirect, Link } from "react-router-dom";
import Moment from "react-moment";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { getSubscriptions } from "../../actions/subscribe";

import LoggedInNav from "../layout/IME/LoggedInNav";
import LoggedInNavRed from "../layout/IME/LoggedInNavRed";
import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";
import GreenLogo from "../layout/Innovators/GreenLogo";
import RedLogo from "../layout/Mentors/RedLogo";
import BlueLogo from "../layout/Employers/BlueLogo";
import SubscribeIMECourses from "../layout/IME/SubscribeIMECourses";
import SubscribeIMEEmployer from "../layout/IME/SubscribeIMEEmployer";

const Subscriptions = ({
  match,
  auth: { user },
  isAuthenticated,
  getSubscriptions,
  subscribe: { subscriptions },
}) => {
  const [showSubscription, setshowSubscription] = useState(false);
  const [showEmployerSubscription, setShowEmployerSubscription] =
    useState(false);

  useEffect(() => {
    getSubscriptions(match.params.channelid);
  }, [getSubscriptions, match.params.channelid]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {showSubscription && (
        <SubscribeIMECourses
          user={user}
          setshowSubscription={setshowSubscription}
        />
      )}
      {showEmployerSubscription && (
        <SubscribeIMEEmployer
          user={user}
          setShowEmployerSubscription={setShowEmployerSubscription}
        />
      )}
      {user && user.role === "innovator" && <LoggedInNav />}
      {user && user.role === "mentor" && <LoggedInNavRed />}
      {user && user.role === "employer" && <LoggedInNavBlue />}
      {user && (
        <div className="flex-all-content-fixed">
          <div className="sub-ime-container">
            <section className="banner-hero-alt">
              <div className="banner-section-name">
                <h1
                  className={`large-font ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                >
                  Subscriptions
                </h1>
              </div>
            </section>
          </div>
          <div className="subscription-header-container">
            {user && user.role === "employer" && (
              <div className="sub-section-container-alt">
                <div className="flex-only">
                  <p className="sub-section blue">ime Subscriptions</p>
                </div>
              </div>
            )}
            {user && user.role === "employer" && (
              <div className="all-subscriptions">
                {subscriptions &&
                  subscriptions.length > 0 &&
                  subscriptions.map((subscription) => {
                    if (
                      subscription.plantype === "Silver" &&
                      subscription.active
                    ) {
                      return (
                        <div class="subscription-alt">
                          <div class="subscription-logo-container">
                            <div class="subscription-logo">
                              <BlueLogo />
                            </div>
                          </div>
                          <p class="subscription-title blue">Silver Package</p>
                          <div class="subscription-body">
                            <div>
                              <p class="subscription-description">
                                ime's Silver Package consists of one (1) job
                                posting for 30 days, alongside one (1) Job Live
                                Stream and one (1) VR Tour post. This package is
                                tailored towards employers looking to hire for a
                                small team.
                              </p>
                            </div>
                            <div>
                              <ul>
                                <li className="sub-facts white">
                                  <i className="fas fa-exclamation mr-10 ml fa-lg blue"></i>
                                  Subscription expires in{" "}
                                  <span className="blue large-font-alt">
                                    <Moment
                                      date={subscription.expirationdate}
                                      durationFromNow
                                    />
                                  </span>{" "}
                                </li>
                                {subscription.autorenew && (
                                  <li className="sub-facts white">
                                    <i className="fas fa-exclamation mr-10 ml fa-lg blue"></i>
                                    Subscription renews in{" "}
                                    <span className="blue large-font-alt">
                                      <Moment
                                        date={subscription.expirationdate}
                                        durationFromNow
                                      />
                                    </span>{" "}
                                  </li>
                                )}
                                {subscription.autorenew && (
                                  <li className="sub-facts white">
                                    <i className="fas fa-cog mr-10 fa-lg blue"></i>
                                    Subscription set to auto-renew,{" "}
                                    <Link
                                      to={`/${user && user.channelid}/settings`}
                                    >
                                      <span className="blue medium-font">
                                        change setting?
                                      </span>
                                    </Link>
                                  </li>
                                )}
                              </ul>
                              <div class="subscription-price">
                                <p class="price blue">$100.00 / month</p>
                                <br />
                                <p class="disclaimer">
                                  Lorem ipsum dolor sit amet consectetur
                                  adipisicing elit. Iste laborum perferendis cum
                                  iusto quod molestiae ab nisi? Optio, enim
                                  iste.
                                </p>
                              </div>
                              <button
                                class="subscription-button background-blue"
                                onClick={() =>
                                  setShowEmployerSubscription(true)
                                }
                              >
                                Subscribe Now!
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    }

                    if (
                      subscription.plantype === "Gold" &&
                      subscription.active
                    ) {
                      return (
                        <div class="subscription-alt">
                          <div class="subscription-logo-container">
                            <div class="subscription-logo">
                              <BlueLogo />
                            </div>
                          </div>
                          <p class="subscription-title blue">Gold Package</p>
                          <div class="subscription-body">
                            <div>
                              <p class="subscription-description">
                                ime's Gold Package provides you with the ability
                                to post up to 50 job postings in a month,
                                expiring 30 days after initial posting. Each job
                                post is parterned with one (1) Job Stream and
                                one (1) VR Tour per post.
                              </p>
                            </div>
                            <div>
                              <ul>
                                <li className="sub-facts white">
                                  <i className="fas fa-exclamation mr-10 ml fa-lg blue"></i>
                                  Subscription expires in{" "}
                                  <span className="blue large-font-alt">
                                    <Moment
                                      date={subscription.expirationdate}
                                      durationFromNow
                                    />
                                  </span>{" "}
                                </li>
                                {subscription.autorenew && (
                                  <li className="sub-facts white">
                                    <i className="fas fa-exclamation mr-10 ml fa-lg blue"></i>
                                    Subscription renews in{" "}
                                    <span className="blue large-font-alt">
                                      <Moment
                                        date={subscription.expirationdate}
                                        durationFromNow
                                      />
                                    </span>{" "}
                                  </li>
                                )}
                                {subscription.autorenew && (
                                  <li className="sub-facts white">
                                    <i className="fas fa-cog mr-10 fa-lg blue"></i>
                                    Subscription set to auto-renew,{" "}
                                    <Link
                                      to={`/${user && user.channelid}/settings`}
                                    >
                                      <span className="blue medium-font">
                                        change setting?
                                      </span>
                                    </Link>
                                  </li>
                                )}
                              </ul>
                              <div class="subscription-price">
                                <p class="price blue">$300.00 / month</p>
                                <br />
                                <p class="disclaimer">
                                  Lorem ipsum dolor sit amet consectetur
                                  adipisicing elit. Iste laborum perferendis cum
                                  iusto quod molestiae ab nisi? Optio, enim
                                  iste.
                                </p>
                              </div>
                              <button
                                class="subscription-button background-blue"
                                onClick={() =>
                                  setShowEmployerSubscription(true)
                                }
                              >
                                Subscribe Now!
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    }

                    if (
                      subscription.plantype === "Platinum" &&
                      subscription.active
                    ) {
                      return (
                        <div class="subscription-alt">
                          <div class="subscription-logo-container">
                            <div class="subscription-logo">
                              <BlueLogo />
                            </div>
                          </div>
                          <p class="subscription-title blue">
                            Platinum Package
                          </p>
                          <div class="subscription-body">
                            <div>
                              <p class="subscription-description">
                                Looking to get the most out of your recruiting
                                efforts? ime's Platinum Package is the best fit
                                for you! Post up to 75 jobs per month, expiring
                                30 days after initial posting. These job
                                postings are also paired with one (1) Job Stream
                                and one (1) VR Tour per post. Reach a large
                                audience and explore the many talented and
                                motivated innovators looking to make a
                                difference within your company.The Platinum
                                Package is best tailored for employers looking
                                to hire frequently and for large teams.
                              </p>
                            </div>
                            <div>
                              <ul>
                                <li className="sub-facts white">
                                  <i className="fas fa-exclamation mr-10 ml fa-lg blue"></i>
                                  Subscription expires in{" "}
                                  <span className="blue large-font-alt">
                                    <Moment
                                      date={subscription.expirationdate}
                                      durationFromNow
                                    />
                                  </span>{" "}
                                </li>
                                {subscription.autorenew && (
                                  <li className="sub-facts white">
                                    <i className="fas fa-exclamation mr-10 ml fa-lg blue"></i>
                                    Subscription renews in{" "}
                                    <span className="blue large-font-alt">
                                      <Moment
                                        date={subscription.expirationdate}
                                        durationFromNow
                                      />
                                    </span>{" "}
                                  </li>
                                )}
                                {subscription.autorenew && (
                                  <li className="sub-facts white">
                                    <i className="fas fa-cog mr-10 fa-lg blue"></i>
                                    Subscription set to auto-renew,{" "}
                                    <Link
                                      to={`/${user && user.channelid}/settings`}
                                    >
                                      <span className="blue medium-font">
                                        change setting?
                                      </span>
                                    </Link>
                                  </li>
                                )}
                              </ul>
                              <div class="subscription-price">
                                <p class="price blue">$500.00 / month</p>
                                <br />
                                <p class="disclaimer">
                                  Lorem ipsum dolor sit amet consectetur
                                  adipisicing elit. Iste laborum perferendis cum
                                  iusto quod molestiae ab nisi? Optio, enim
                                  iste.
                                </p>
                              </div>
                              <button
                                class="subscription-button background-blue"
                                onClick={() =>
                                  setShowEmployerSubscription(true)
                                }
                              >
                                Subscribe Now!
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
                <div class="subscription-alt">
                  <div class="subscription-logo-container">
                    <div class="subscription-logo">
                      <BlueLogo />
                    </div>
                  </div>
                  <p class="subscription-title blue">ime Courses</p>
                  <div class="subscription-body">
                    <div>
                      <p class="subscription-description">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Numquam aliquam iure delectus repudiandae incidunt, fuga
                        repellendus aut veniam nam placeat eveniet nisi ea
                        obcaecati ad ipsam assumenda dolorem! Veniam tenetur
                        temporibus quibusdam voluptate, dicta magni iusto itaque
                        earum illum, velit, cumque delectus provident ipsa eius
                        dolor facilis doloremque nihil minima.
                      </p>
                    </div>
                    <div>
                      <ul>
                        <li className="sub-facts white">
                          <i className="fas fa-exclamation mr-10 ml fa-lg blue"></i>
                          Subscription expires in{" "}
                          <span className="blue large-font-alt">7</span> days
                        </li>
                        <li className="sub-facts white">
                          <i className="fas fa-exclamation mr-10 ml fa-lg blue"></i>
                          Subscription renews in{" "}
                          <span className="blue large-font-alt">7</span> days
                        </li>
                        <li className="sub-facts white">
                          <i className="fas fa-cog mr-10 fa-lg blue"></i>
                          Subscription set to auto-renew,{" "}
                          <Link to={`/${user && user.channelid}/settings`}>
                            <span className="blue medium-font">
                              change setting?
                            </span>
                          </Link>
                        </li>
                      </ul>
                      <div class="subscription-price">
                        <p class="price blue">$30.00 / month</p>
                        <br />
                        <p class="disclaimer">
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Iste laborum perferendis cum iusto quod
                          molestiae ab nisi? Optio, enim iste.
                        </p>
                      </div>
                      <button
                        class="subscription-button background-blue"
                        onClick={() => setshowSubscription(true)}
                      >
                        Subscribe Now!
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {user && user.role === "innovator" && (
              <div className="sub-section-container-alt">
                <div className="flex-only">
                  <p className="sub-section green">Your Subscriptions</p>
                </div>
              </div>
            )}
            {user && user.role === "mentor" && (
              <div className="sub-section-container-alt">
                <div className="flex-only">
                  <p className="sub-section red">Your Subscriptions</p>
                </div>
              </div>
            )}
            {user &&
              user.role === "innovator" &&
              subscriptions &&
              subscriptions.length <= 0 && (
                <p className="empty-content-alt green">No Subscriptions</p>
              )}
            {user &&
              user.role === "mentor" &&
              subscriptions &&
              subscriptions.length <= 0 && (
                <p className="empty-content-alt red">No Subscriptions</p>
              )}
            {user && user.role === "innovator" && (
              <div className="all-subscriptions">
                {subscriptions &&
                  subscriptions.length > 0 &&
                  subscriptions.map((subscription) => {
                    if (subscription.active) {
                      return (
                        <div class="subscription-alt">
                          <div class="subscription-logo-container">
                            <div class="subscription-logo">
                              <GreenLogo />
                            </div>
                          </div>
                          <div class="subscription-body-alt">
                            <div>
                              <div className="subscriber-avi-container">
                                <div className="avi-color-border green">
                                  <img
                                    className="subscriber-avi"
                                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${subscription.avatar}`}
                                    alt=""
                                  />
                                </div>
                              </div>
                              <p class="subscription-title-name green">
                                {subscription.channelid}
                              </p>
                              <p class="subscription-title-alt white">
                                {subscription.jobtitle}
                              </p>
                              <p class="subscription-title-alt white">
                                {subscription.location.city},{" "}
                                {subscription.location.state}
                              </p>
                            </div>
                            <div className="middle-list">
                              <ul>
                                <li className="sub-facts white">
                                  <i className="far fa-calendar-alt mr-10 fa-lg green"></i>
                                  <span className="green large-font-alt mr-5">
                                    {subscription.monthssubscribed}
                                  </span>
                                  Month(s) Subscribed
                                </li>
                                <li className="sub-facts white">
                                  <i className="fas fa-exclamation mr-10 ml fa-lg green"></i>
                                  Subscription expires in{" "}
                                  <span className="green large-font-alt">
                                    <Moment
                                      date={subscription.expirationdate}
                                      durationFromNow
                                    />
                                  </span>{" "}
                                </li>
                                {subscription.autorenew && (
                                  <li className="sub-facts white">
                                    <i className="fas fa-exclamation mr-10 ml fa-lg green"></i>
                                    Subscription renews in{" "}
                                    <span className="green large-font-alt">
                                      <Moment
                                        date={subscription.expirationdate}
                                        durationFromNow
                                      />
                                    </span>{" "}
                                  </li>
                                )}
                                {subscription.autorenew && (
                                  <li className="sub-facts white">
                                    <i className="fas fa-cog mr-10 fa-lg green"></i>
                                    Subscription set to auto-renew,{" "}
                                    <Link
                                      to={`/${user && user.channelid}/settings`}
                                    >
                                      <span className="green medium-font">
                                        change setting?
                                      </span>
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                            <div>
                              <div class="subscription-price">
                                <p class="price green">$5.00 / month</p>
                                <br />
                                <p class="disclaimer">
                                  Lorem ipsum dolor sit amet consectetur
                                  adipisicing elit. Iste laborum perferendis cum
                                  iusto quod molestiae ab nisi? Optio, enim
                                  iste.
                                </p>
                              </div>
                              <button class="subscription-button background-green">
                                <i className="fas fa-check-circle mr-5"></i>
                                Subscribed
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
              </div>
            )}
            {user && user.role === "mentor" && (
              <div className="all-subscriptions">
                {subscriptions &&
                  subscriptions.length > 0 &&
                  subscriptions.map((subscription) => {
                    if (subscription.active) {
                      return (
                        <div class="subscription-alt">
                          <div class="subscription-logo-container">
                            <div class="subscription-logo">
                              <RedLogo />
                            </div>
                          </div>
                          <div class="subscription-body-alt">
                            <div>
                              <div className="subscriber-avi-container">
                                <div className="avi-color-border red">
                                  <img
                                    className="subscriber-avi"
                                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${subscription.avatar}`}
                                    alt=""
                                  />
                                </div>
                              </div>
                              <p class="subscription-title-name red">
                                {subscription.channelid}
                              </p>
                              <p class="subscription-title-alt white">
                                {subscription.jobtitle}
                              </p>
                              <p class="subscription-title-alt white">
                                {subscription.location.city},{" "}
                                {subscription.location.state}
                              </p>
                            </div>
                            <div className="middle-list">
                              <ul>
                                <li className="sub-facts white">
                                  <i className="far fa-calendar-alt mr-10 fa-lg red"></i>
                                  <span className="red large-font-alt mr-5">
                                    {subscription.monthssubscribed}
                                  </span>
                                  Month(s) Subscribed
                                </li>
                                <li className="sub-facts white">
                                  <i className="fas fa-exclamation mr-10 ml fa-lg red"></i>
                                  Subscription expires in{" "}
                                  <span className="red large-font-alt">
                                    <Moment
                                      date={subscription.expirationdate}
                                      durationFromNow
                                    />
                                  </span>{" "}
                                </li>
                                {subscription.autorenew && (
                                  <li className="sub-facts white">
                                    <i className="fas fa-exclamation mr-10 ml fa-lg red"></i>
                                    Subscription renews in{" "}
                                    <span className="red large-font-alt">
                                      <Moment
                                        date={subscription.expirationdate}
                                        durationFromNow
                                      />
                                    </span>{" "}
                                  </li>
                                )}
                                {subscription.autorenew && (
                                  <li className="sub-facts white">
                                    <i className="fas fa-cog mr-10 fa-lg red"></i>
                                    Subscription set to auto-renew,{" "}
                                    <Link
                                      to={`/${user && user.channelid}/settings`}
                                    >
                                      <span className="red medium-font">
                                        change setting?
                                      </span>
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                            <div>
                              <div class="subscription-price">
                                <p class="price red">$5.00 / month</p>
                                <br />
                                <p class="disclaimer">
                                  Lorem ipsum dolor sit amet consectetur
                                  adipisicing elit. Iste laborum perferendis cum
                                  iusto quod molestiae ab nisi? Optio, enim
                                  iste.
                                </p>
                              </div>
                              <button class="subscription-button background-red">
                                <i className="fas fa-check-circle mr-5"></i>
                                Subscribed
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
              </div>
            )}
            {user && user.role === "innovator" && (
              <div className="sub-section-container-alt">
                <div className="flex-only">
                  <p className="sub-section green">ime Subscriptions</p>
                </div>
              </div>
            )}
            {user && user.role === "mentor" && (
              <div className="sub-section-container-alt">
                <div className="flex-only">
                  <p className="sub-section red">ime Subscriptions</p>
                </div>
              </div>
            )}
            {user && user.role === "innovator" && (
              <div className="all-subscriptions">
                <div class="subscription-one">
                  <div class="subscription-logo-container">
                    <div class="subscription-logo">
                      <GreenLogo />
                    </div>
                  </div>
                  <p class="subscription-title green">ime Courses</p>
                  <div class="subscription-body">
                    <p class="subscription-description">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Numquam aliquam iure delectus repudiandae incidunt, fuga
                      repellendus aut veniam nam placeat eveniet nisi ea
                      obcaecati ad ipsam assumenda dolorem! Veniam tenetur
                      temporibus quibusdam voluptate, dicta magni iusto itaque
                      earum illum, velit, cumque delectus provident ipsa eius
                      dolor facilis doloremque nihil minima.
                    </p>
                    <ul>
                      <li className="sub-facts white">
                        <i className="far fa-calendar-alt mr-10 fa-lg green"></i>
                        <span className="green large-font-alt mr-5">7</span>
                        Months Subscribed
                      </li>
                      <li className="sub-facts white">
                        <i className="fas fa-exclamation mr-10 ml fa-lg green"></i>
                        Subscription expires in{" "}
                        <span className="green large-font-alt">7</span> days
                      </li>
                      <li className="sub-facts white">
                        <i className="fas fa-exclamation mr-10 ml fa-lg green"></i>
                        Subscription renews in{" "}
                        <span className="green large-font-alt">7</span> days
                      </li>
                      <li className="sub-facts white">
                        <i className="fas fa-cog mr-10 fa-lg green"></i>
                        Subscription set to auto-renew,{" "}
                        <Link to={`/${user && user.channelid}/settings`}>
                          <span className="green medium-font">
                            change setting?
                          </span>
                        </Link>
                      </li>
                    </ul>
                    <div class="subscription-price">
                      <p class="price green">$30.00 / month</p>
                      <br />
                      <p class="disclaimer">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Iste laborum perferendis cum iusto quod molestiae ab
                        nisi? Optio, enim iste.
                      </p>
                    </div>
                    <button
                      class="subscription-button background-green"
                      onClick={() => setshowSubscription(true)}
                    >
                      Subscribe Now!
                    </button>
                  </div>
                </div>
              </div>
            )}
            {user && user.role === "mentor" && (
              <div className="all-subscriptions">
                <div class="subscription-one">
                  <div class="subscription-logo-container">
                    <div class="subscription-logo">
                      <RedLogo />
                    </div>
                  </div>
                  <p class="subscription-title red">ime Courses</p>
                  <div class="subscription-body">
                    <p class="subscription-description">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Numquam aliquam iure delectus repudiandae incidunt, fuga
                      repellendus aut veniam nam placeat eveniet nisi ea
                      obcaecati ad ipsam assumenda dolorem! Veniam tenetur
                      temporibus quibusdam voluptate, dicta magni iusto itaque
                      earum illum, velit, cumque delectus provident ipsa eius
                      dolor facilis doloremque nihil minima.
                    </p>
                    <ul>
                      <li className="sub-facts white">
                        <i className="far fa-calendar-alt mr-10 fa-lg red"></i>
                        <span className="red large-font-alt mr-5">7</span>
                        Months Subscribed
                      </li>
                      <li className="sub-facts white">
                        <i className="fas fa-exclamation mr-10 ml fa-lg red"></i>
                        Subscription expires in{" "}
                        <span className="red large-font-alt">7</span> days
                      </li>
                      <li className="sub-facts white">
                        <i className="fas fa-exclamation mr-10 ml fa-lg red"></i>
                        Subscription renews in{" "}
                        <span className="red large-font-alt">7</span> days
                      </li>
                      <li className="sub-facts white">
                        <i className="fas fa-cog mr-10 fa-lg red"></i>
                        Subscription set to auto-renew,{" "}
                        <Link to={`/${user && user.channelid}/settings`}>
                          <span className="red medium-font">
                            change setting?
                          </span>
                        </Link>
                      </li>
                    </ul>
                    <div class="subscription-price">
                      <p class="price red">$30.00 / month</p>
                      <br />
                      <p class="disclaimer">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Iste laborum perferendis cum iusto quod molestiae ab
                        nisi? Optio, enim iste.
                      </p>
                    </div>
                    <button
                      class="subscription-button background-red"
                      onClick={() => setshowSubscription(true)}
                    >
                      Subscribe Now!
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

Subscriptions.propTypes = {
  auth: PropTypes.object.isRequired,
  getSubscriptions: PropTypes.func.isRequired,
  subscribe: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
  subscribe: state.subscribe,
});

export default connect(mapStateToProps, {
  getSubscriptions,
})(Subscriptions);
